/*!
 * Type Preview Element: video
 */

var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "preview.video",
  alias: ["pages.preview.video"],
  title: "Preview: Video",
  description: "Modern preview card for Video pages.",
  pagePreview: {
    pageType: "pages.video"
  },
  fields: {
    title: { title: "Title", type: "string", description: "Title." },
    description: { title: "Description", type: "string", description: "Description." },
    image: { title: "Image", type: "uri", description: "Image URL." },
    url: { title: "URL", type: "uri", description: "Destination URL." },
    pageType: { title: "Page Type", type: "string", description: "Type namespace." },
    mainMedia: { title: "Main Media", type: ["object", "uri"], description: "Primary media." },
    video: { title: "Video", type: ["object", "uri"], description: "Video source." },
    audio: { title: "Audio", type: "uri", description: "Audio source." },
    embed: { title: "Embed", type: ["object", "uri"], description: "Embed source." },
    platformLinks: { title: "Platform Links", type: "object", description: "External platform links." },
    contentHighlights: { title: "Highlights", type: "list", description: "Highlight list." },
    recipe: { title: "Recipe", type: "object", description: "Recipe metadata." },
    on: { title: "Dates", type: "object", description: "Dates." }
  },
  supportServer: true,
  passthrough: true
});

var KIND = "video";

function str(value, fallback){
  if (value === undefined || value === null || value === "") return fallback || "";
  return value + "";
}

function list(value){
  if (value === undefined || value === null) return [];
  if (Array.isArray(value)) return value;
  return [value];
}

function mediaSource(options){
  var media = options.mainMedia;
  if (typeof media === "string") return { kind: "image", src: media, poster: options.image || "" };
  if (media && typeof media === "object") return { kind: str(media.kind, "image").toLowerCase(), src: media.src || media.url || media.href || "", poster: media.poster || options.image || "", alt: media.alt || options.title || "", title: media.title || "" };
  if (options.video) {
    if (typeof options.video === "string") return { kind: "video", src: options.video, poster: options.image || "" };
    return { kind: "video", src: options.video.src || options.video.url || "", poster: options.video.poster || options.image || "" };
  }
  if (options.audio) return { kind: "audio", src: options.audio };
  if (options.embed) {
    if (typeof options.embed === "string") return { kind: "embed", src: options.embed, title: "Embedded media" };
    return { kind: "embed", src: options.embed.src || "", title: options.embed.title || "Embedded media" };
  }
  if (options.image) return { kind: "image", src: options.image, alt: options.title || "" };
  return null;
}

function mediaNode(media, options){
  if (!media || !media.src) return { n: "div", c: "rounded border", s: "min-height:10rem;" };
  if (media.kind === "video") return { n: "video", controls: true, preload: "none", src: media.src, poster: media.poster || options.image || "", c: "w-100 rounded", s: "max-height:15rem;object-fit:cover;" };
  if (media.kind === "audio") return { n: "audio", controls: true, preload: "none", src: media.src, c: "w-100" };
  if (media.kind === "embed") return { n: "div", c: "ratio ratio-16x9 rounded border overflow-hidden", i: { n: "iframe", src: media.src, title: media.title || "Embedded media", loading: "lazy", allowfullscreen: true, referrerpolicy: "no-referrer" } };
  return { n: "img", src: media.src, alt: media.alt || str(options.title, "Preview"), loading: "lazy", c: "w-100 rounded", s: "max-height:15rem;object-fit:cover;" };
}

function tags(options){
  var out = list(options.contentHighlights).map(function(i){return str(i,"");}).filter(Boolean).slice(0,3);
  if ((KIND === "recipe") && options.recipe && options.recipe.totalTime) out.push("Total: " + options.recipe.totalTime);
  if (options.on && options.on.published) out.push("Published: " + options.on.published);
  return out;
}

function linkTags(options){
  var links = options.platformLinks || {};
  return [
    ["Spotify", links.spotify],
    ["Apple", links.applePodcasts],
    ["YouTube", links.youtube],
    ["SoundCloud", links.soundcloud]
  ].filter(function(it){return !!it[1];}).map(function(it){
    return { n: "a", href: it[1], target: "_blank", rel: "noopener noreferrer", c: "badge text-bg-light border text-decoration-none", s: "padding:0.45rem 0.7rem;", i: it[0] };
  });
}

exports.render = async function(options){
  var media = mediaSource(options);
  var chips = tags(options);
  var linkChips = linkTags(options);

  return [{
    n: "div",
    c: "col-12",
    i: {
      n: "article",
      c: "p-3 p-md-4 rounded border h-100 bg-og-75-background",
      // s: "background: linear-gradient(140deg, rgba(255,255,255,.97), rgba(246,248,251,.95));",
      i: [
        { n: "p", c: "text-uppercase fw-semibold mb-2", s: "font-size:.78rem;letter-spacing:.08rem;", i: "Video" },
        { n: "h3", c: "h5 mb-2", i: str(options.title, "Video") },
        mediaNode(media, options),
        { n: "p", c: "mt-3 mb-2", i: str(options.description, "Video preview.") },
        chips.length ? { n: "div", c: "d-flex flex-wrap gap-2 mb-2", i: chips.map(function(c){ return { n: "span", c: "badge text-bg-secondary", s: "padding:.42rem .66rem;", i: c }; }) } : { n: "span", c: "d-none", i: "" },
        linkChips.length ? { n: "div", c: "d-flex flex-wrap gap-2 mb-3", i: linkChips } : { n: "span", c: "d-none", i: "" },
        { n: "div", c: "d-flex justify-content-end", i: { n: "a", href: str(options.url, "#"), c: "btn btn-sm btn-primary", i: "Watch" } }
      ]
    }
  }];
};
